import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Interno from './interno';
import { SttAlerta, SttLoading } from '@stt-componentes/core';
import Erro from './erro';
import alerta from '../signals/alerta';
import carregando from '../signals/carregando';
import { useSignals } from '@preact/signals-react/runtime';

const Home = () => {
    useSignals();

    return (
        <BrowserRouter basename={`/${global.gConfig.basename}`}>
            <Routes>
                <Route path="/erro" exact element={<Erro />} />
                <Route path="*" element={<Interno />} />
            </Routes>
            <SttAlerta {...alerta.value} />
            <SttLoading {...carregando.value} />
        </BrowserRouter>
    );
};

export default Home;
